<template>
  <sui-segment>
    <v-simple-table v-if="!this.empty" fixed-header max-height="1300px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="cart-row"></th>
            <th class="cart-row">{{ $t("name") }}</th>
            <!-- <th class="cart-row">{{ $t("price") }}</th> -->
            <th class="cart-row">{{ $t("amount") }}</th>
            <th class="cart-row">{{ $t("extras") }}</th>
            <th class="cart-row right"></th>
          </tr>
        </thead>
        <br />
        <tbody>
          <tr v-for="item in cart" :key="item.id" style="padding: 120px">
            <td>
              <v-img :src="item.product.image" class="cartprod-img"></v-img>
            </td>
            <td>{{ item.product.name }}</td>
            <!-- <td>
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(item.product.price * item.product_amount)
              }}
            </td> -->
            <td>{{ item.product_amount }}</td>
            <td>{{renderExtras(item)}}</td>
            <td class="cart-row right">
              <v-btn :title="$t('editCartItem')" color="yellow darken-3" @click.prevent="editCartItem(item)"
                ><v-icon>mdi-wrench</v-icon></v-btn
              >
			  <v-btn :title="$t('checkoutOne')" color="green" @click.prevent="checkoutOne(item)">
				  <v-icon>mdi-cart</v-icon>
			  </v-btn>
              <v-btn :title="$t('removeFromCart')" color="red" @click.prevent="removeFromCart(item)"
                ><v-icon>mdi-trash-can</v-icon></v-btn
              >
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
	<div v-else>
	  <v-banner
		color="grey lighten-2"
		style="text-align:center;"
		> {{$t("emptyCart")}} </v-banner>
		<br>
	</div>
    <hr />
    <div class="cart-information">
      {{ $t("totalitems") }}: {{ totalitems }}<br />
      {{ $t("diffitems") }}: {{ diffitems }}<br />
      <!-- {{ $t("totalprice") }}:
      {{
        new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "EUR",
        }).format(totalprice)
      }}<br />
      {{ $t("tax") }}:
      {{
        new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "EUR",
        }).format(tax)
      }}<br />
      {{ $t("withtax") }}:
      {{
        new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "EUR",
        }).format(totalprice + tax)
      }} -->
	  <br />
    </div>

    <v-btn block elevation="2" :disabled="empty || cart.length <= 0 || loading == true" color="success" @click.prevent="checkout">{{
      $t("checkout")
    }}</v-btn>

    <sui-modal v-model="showEditModal">
      <sui-modal-header>{{ $t("editCartItem") }}</sui-modal-header>
      <sui-modal-content image>
        <sui-image class="prod-img" :src="currProd.image"></sui-image>

        <sui-modal-description>
          <sui-header>{{ currProd.name }}</sui-header>
          <p>
            {{ currProd.description }}
          </p>
          <!-- <p>
            {{
              new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
              }).format(currProd.price * 1 * (currProd.amount * 1))
            }}
          </p> -->
          <v-text-field
            v-model="currProd.amount"
            type="number"
            min="1"
            max="99"
            @change="$forceUpdate()"
            :label="$t('amount')"
          ></v-text-field>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button positive @click.native="saveChangeItem">
          {{ $t("edit") }}
        </sui-button>
      </sui-modal-actions>
    </sui-modal>
  </sui-segment>
</template>

<script>
import ApiService from "@/services/ApiService.js";
export default {
  data() {
    return {
		empty: false,
      cart: {},
      totalitems: 0,
      diffitems: 0,
      loading: false,
      tax: 0,
      showEditModal: false,
      currProd: {},
    };
  },
  async created() {
    this.renderContent();
  },
  methods: {
    async renderContent() {
      this.loading = true
      let resp = await ApiService.getCart();
      if (resp.status == 200) {
        this.totalitems = resp.data.totalitems;
        this.diffitems = resp.data.diffitems;
        // this.totalprice = resp.data.totalprice;
        this.cart = resp.data.cart;

        // this.tax = (this.totalprice / 100) * 19;
      }else if(resp.status == 204){
		  this.empty = true
	    }
		  this.$emit("updateNotis")
      this.loading =false
    },
    		renderExtras(item){
			if(item.size == null && item.color == null){
				return this.$t("noData")
			}
			let out = "";
			if(item.size){
				out += this.$t("size") + ": " + item.size
			}
			if(item.color){
				out == "" ? "" : out += ", "
				out += this.$t("color") + ": " + item.color
			}
			return out;
		},
    async removeFromCart(row) {
		this.$swal.fire({
			icon: "warning",
			title: this.$t("areYouSure"),
			text: this.$t("youCantRevert"),
			showCancelButton: false,
			showDenyButton: true,
			confirmButtonText: this.$t('yesDelete'),
			denyButtonText: this.$t("noKeep")
			}).then(async(result) => {
			/* Read more about isConfirmed, isDenied below */
			if (result.isConfirmed) {
				let res = await ApiService.removeFromCart(row.id);
				if (res===false) {
					this.renderContent();
				}
			}
		})
    },
	async checkoutOne(row){
		let res = await ApiService.postCheckoutOne(row.id)
		if(res.data == "checkedOut"){
		  this.$emit("updateNotis")
			this.$router.push("/checkout?success=true")
		}
	},
    editCartItem(row) {
      this.currProd = row.product;
      this.currProd.id = row.id;
      this.currProd.amount = row.product_amount;
      this.showEditModal = true;
    },
    async saveChangeItem() {
      let res = await ApiService.editCartItem(this.currProd.id,{
        amount: this.currProd.amount,
      });
      if (res.status == 200) {
        this.showEditModal = false;
        this.renderContent();
      }
    },
    async checkout(){
    	let resp = await ApiService.postCheckoutAll()
		if(resp.data == "checkedOut"){
		  this.$emit("updateNotis")
			this.$router.push("/checkout?success=true")
		}
    }
  },
};
</script>

<style>
.cartprod-img {
  max-height: 100px;
  max-width: 100px;
  margin: 20px;
}
.cart-row {
  max-width: 450px;
}
.cart-row.right {
  text-align: right;
}
.cart-information {
  text-align: right;
  margin-bottom: 40px;
  margin-top: 20px;
  margin-right: 3%;
}
</style>